import { api } from './api';

interface Role {
  id: string;
  code: string;
  name: string;
  description?: string;
  type: string;
  color?: string;
  labelColor?: string;
}

interface UserProfile {
  id: string;
  name: string;
  email: string;
  isAdmin: boolean;
  avatarBase64?: string;
  customer_id?: string;
  role?: Role;
  authenticationType?: string;
  teams?: string[];
}

class UserProfileService {
  /**
   * Busca os dados completos do usuário incluindo avatar
   * @param userId ID do usuário
   * @returns Dados completos do usuário
   */
  async getUserProfile(userId: string): Promise<UserProfile | null> {
    try {
      const response = await api.get(`/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar perfil do usuário:', error);
      return null;
    }
  }

  /**
   * Busca apenas o avatar do usuário
   * @param userId ID do usuário
   * @returns URL do avatar ou null
   */
  async getUserAvatar(userId: string): Promise<string | null> {
    try {
      const response = await api.get(`/users/${userId}/avatar`);
      return response.data.avatarUrl;
    } catch (error) {
      console.error('Erro ao buscar avatar do usuário:', error);
      return null;
    }
  }
}

export const userProfileService = new UserProfileService();
